import { AnimatePresence } from 'framer-motion';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes/AppRoutes';

export default function App() {
  return (
    <AnimatePresence mode="wait">
      <BrowserRouter>
          <AppRoutes />
      </BrowserRouter>
    </AnimatePresence>
  );
}
